export const credentialsResourceType = "credentials" as const;
